import type { FC } from 'react';
import { Navigate, useParams } from 'react-router';
import GoToTestForm from './GoToTestForm';
import FormSkeleton from './FormSkeleton';
import { SuspenseBoundary } from 'components/common';
import { cabinetDatadogSources } from 'lib/datadog';
import { useGoToTestDetails } from 'features/cabinet/tiktok/api';

const EditGoToTestComponent: FC = () => {
  const { goToTestId } = useParams();
  const { data } = useGoToTestDetails({ params: { id: goToTestId } });

  if (!goToTestId) return <Navigate to={'/'} />;
  return <GoToTestForm data={data} />;
};

const EditGoToTest: FC = () => {
  return (
    <SuspenseBoundary
      fallback={<FormSkeleton />}
      datadogSource={cabinetDatadogSources.detailsQuery('tiktok', 'go_to_test')}
    >
      <EditGoToTestComponent />
    </SuspenseBoundary>
  );
};

export default EditGoToTest;
